import { ElementType, forwardRef, ReactNode, memo } from "react"

export interface CampaignFormFieldProps {
  as?: ElementType
  children: ReactNode
  wrapperClassName?: string
  innerWrapperClassName?: string
  label?: ReactNode
  labelClassName?: string
  description?: ReactNode
  descriptionClassName?: string
  description2?: ReactNode
  description2ClassName?: string
}

const CampaignFormField = forwardRef<HTMLLabelElement, CampaignFormFieldProps>(
  ({
    as: Component = "label",
    children,
    wrapperClassName,
    innerWrapperClassName,
    label,
    labelClassName,
    description,
    descriptionClassName,
    description2,
    description2ClassName,
  }: CampaignFormFieldProps, ref) => {
    return (
      <Component className={`flex flex-col gap-4 ${wrapperClassName || ""}`} ref={ref}>
        {(label || description || description2) && (
          <div className={`flex flex-col gap-2 ${innerWrapperClassName || ""}`}>
            {label && <p className={`text-base font-bold ${labelClassName || ""}`}>{label}</p>}
            {description && <p className={`text-sm text-[#999] ${descriptionClassName || ""}`}>{description}</p>}
            {description2 && <p className={`text-sm text-[#999] ${description2ClassName || ""}`}>{description2}</p>}
          </div>
        )}
        {children}
      </Component>
    )
  }
)

export default memo(CampaignFormField)
